module.exports = __webpack_public_path__ + "img/10.78b1b110.svg";